import {
    SET_LOADING, SET_CREDITS_TOTAL,SET_CREDIT,SET_CREDITS
} from "./mutations";
import ApiService from "@/core/services/ApiService";

export default {
  async fetchMgmtCreditForms({ commit },  params = {}) {
    commit(SET_LOADING, true);
    ApiService.setHeader();
    return await ApiService.query("mgmt/credit_request",params)
        .then((result) => {
          result =result.data;
          commit(SET_CREDITS, result?.data ?? []);
          commit(SET_CREDITS_TOTAL, result?.total ?? []);
          commit(SET_LOADING, false);

          return result;
        })
        .catch(({response}) => {
          // console.log('error response', response);
          commit(SET_LOADING, false);
        });
  },
  async fetchMgmtCreditForm({ commit }, id) {
    commit(SET_LOADING, true);
    ApiService.setHeader();
    return await ApiService.get(`mgmt/credit_request/${id}`)
        .then((result) => {
          commit(SET_CREDIT, result?.data ?? {});
          commit(SET_LOADING, false);
          return result;
        })
        .catch(({response}) => {
          // console.log('error response', response);
          commit(SET_CREDIT, { success: false });

        });

  },
  async updateMgmtCreditForm({ commit }, params) {
    commit(SET_LOADING, true);
    ApiService.setHeader();
    return await ApiService.put("mgmt/credit_request/"+params.apply_form_id, params)
        .then((result) => {
          result = result.data;

          return result;
        })
        .catch(({response}) => {
          // console.log('error response', response.data);
          return response.data;
        });
  },
};
